module.exports = __webpack_public_path__ + "img/fantasy2.e6d77425.png";